import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DoctorService} from "../../_services/doctor.service";
import {PatientsService} from "../../_services/patients.service";
import {ToasterService} from "../../_services/toaster.service";
declare var $: any;

@Component({
  selector: 'app-transfer-list',
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.css']
})
export class TransferListComponent implements OnInit {

  userdetaild: string;
  submitted = false;
  baseUrl: string = environment.baseUrl;

  returnUrl: string;
  userData: any[] = [];


  // tslint:disable-next-line:max-line-length
  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private patientsservice: PatientsService ,private toaster: ToasterService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();


    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    const payload = {
      to_docid: ''
    };

    this.getTransferList(payload);


  }





  getTransferList(payload) {
    this.doctorservice.getTransferList(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.userData = data.Data;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
            // console.log(this.userData);
          }else{
            this.toaster.showWarning('Transfer', data.ResponseMessage);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('Transfer', error);
          setTimeout(()=>{
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deleteTransfer(id){
    let payload = {
      id: id
    };
    this.removeTransfer(payload);
  }


  removeTransfer(payload) {
    this.doctorservice.removeTransfer(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.reloadComponent();
            this.toaster.showSuccess('Transfer', data.ResponseMessage);
          }else{
            this.toaster.showWarning('Transfer', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Transfer', error);
        });
  }


  reloadComponent() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/transfer-list']);
  }

}
